<button mat-icon-button [disabled]="disabled" (click)="onClick.emit()">
  <ng-content></ng-content>
</button>
